import { useMutation, useQuery } from "@apollo/react-hooks";

import Toast from "shared/toast";

import { DeleteComment, SaveComment, UnfollowThreads, FollowThreads } from "calls/components/graphql/Comments.graphql";
import { ListMembers } from "calls/components/graphql/Members.graphql";

export const useOnSave = () => {
  const [saveComment] = useMutation(SaveComment);

  const createCommentOnThread = async ({ threadId, richText, mentions }) => {
    await saveComment({
      variables: {
        attributes: { richText, mentions },
        search: {
          threadHashid: threadId
        }
      }
    });
  };

  const updateComment = async ({ threadId, commentId, richText }) => {
    await saveComment({
      variables: {
        attributes: { richText },
        search: {
          commentHashid: commentId,
          threadHashid: threadId
        }
      }
    });
  };

  return async ({ threadId, commentId, richText, mentions }) => {
    commentId ? await updateComment({ threadId, commentId, richText }) : await createCommentOnThread({ threadId, richText, mentions });
  };
};

export const useOnDelete = () => {
  const [deleteComment] = useMutation(DeleteComment);

  return async ({ commentId }) => {
    await deleteComment({ variables: { hashid: commentId } });
  };
};

export const useOnFollowingToggle = () => {
  const [followThreads] = useMutation(FollowThreads);
  const [unfollowThreads] = useMutation(UnfollowThreads);

  return async ({ threadId, following }) => {
    try {
      following
        ? await unfollowThreads({ variables: { hashids: [threadId] } })
        : await followThreads({ variables: { hashids: [threadId] } });
      return true;
    } catch (error) {
      const action = following ? "unfollow" : "follow";
      Toast.error({
        title: `Error ${action}ing thread`,
        message: `An error occurred while trying to ${action} a thread. Please try again.`
      });
    }
  };
};

export const useUserMentionsData = () => {
  const { refetch: membersData } = useQuery(ListMembers, { skip: true });

  return async (query) => {
    const { data } = await membersData({ searchString: query });
    if (data && data.members) {
      return data.members.map(({ id, name: display, email, role }) => ({ id, display, email, role }));
    }
  };
};
